import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons';
import Editor from '@monaco-editor/react';
import jsQR from 'jsqr';
import commonFunc from '../common';

const QrCodeScannerPage = (props) => {
  const { editorTheme } = props
  const [qrCodeData, setQrCodeData] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const file = event.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      handleReadImage(file)
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleReadImage(file)
    }
  };

  const handleReadImage = (file) => {
    const reader = new FileReader();

    reader.onload = () => {
      const image = new Image();
      image.src = reader.result;
      setImageSrc(image.src);

      image.onload = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0, canvas.width, canvas.height);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height);

        if (code) {
          setQrCodeData(code.data);;
        } else {
          commonFunc.notifyFailure('No QR code found')
          setQrCodeData(null);
        }
      };
    };

    reader.readAsDataURL(file);
  }

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Select QR Image</h3>
          </div>
          <div
            onClick={() => document.querySelector('input[name="file"]').click()}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            className="flex h-60 flex-col justify-center items-center text-center px-4 py-2 text-gray-400 border-2 border-gray-700 border-dashed rounded dark:border-gray-600"
          >
            <input name='file' className='hidden' type="file" accept="image/*" onChange={handleImageUpload} />
            <div class="text-gray-700">
              <FontAwesomeIcon icon={faCloudArrowUp}/>
            </div>
            <div class="text-gray-700 dark:text-gray-200 font-normal">
              Drag your QR Code image here, or click to <strong>browse</strong>
            </div>
          </div>
        </div>
      </div>
      <div className="col-span-full xl:col-auto">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>QR Code Preview</h3>
          </div>
          <div className="px-4 flex justify-center items-center text-center h-60 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            { imageSrc && (
              <img src={imageSrc} alt="Dropped" className="h-full text-center max-w-xs" />
            ) }
          </div>
        </div>
      </div>
      <div className="col-span-full">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>Scanned Data</h3>
          </div>
          <div className="h-60 px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <Editor 
              height="100%"
              value={qrCodeData}
              language={'txt'}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default QrCodeScannerPage;
